export function toWebp(src: string): string {
    return src.replace(/\.jpg|\.jpeg/i, '.webp');
}